export default {
  fileGroupsOptions: ({ fileGroups }) => fileGroups?.map(
    (item) => ({ label: item.name, value: item.id, isDefault: item.default }),
  ) || [],
}
